import { render, staticRenderFns } from "./CategoryBreadcrumbs.vue?vue&type=template&id=b4e92f18&"
import script from "./CategoryBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./CategoryBreadcrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports